export default {
  FORGOT_PASSWORD: {
    TITLE: 'Find your account',
    SUBTITLE: 'Please enter your email address to search for your account.',
    BUTTON: 'Search',
    SUCCESS_MESSAGE: 'An email containing your reset password link has been sent. Please check your inbox or spam folder.',
    ERROR_MESSAGE: 'Failed to send the email containing your reset password, please contact our support.'
  }
}
